/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SupplementalAttachment } from './SupplementalAttachment';
import {
    SupplementalAttachmentFromJSON,
    SupplementalAttachmentFromJSONTyped,
    SupplementalAttachmentToJSON,
} from './SupplementalAttachment';

/**
 * 
 * @export
 * @interface SupplementalFormInstanceWithAttachmentsAllOf
 */
export interface SupplementalFormInstanceWithAttachmentsAllOf {
    /**
     * 
     * @type {Array<SupplementalAttachment>}
     * @memberof SupplementalFormInstanceWithAttachmentsAllOf
     */
    attachments?: Array<SupplementalAttachment>;
}

/**
 * Check if a given object implements the SupplementalFormInstanceWithAttachmentsAllOf interface.
 */
export function instanceOfSupplementalFormInstanceWithAttachmentsAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SupplementalFormInstanceWithAttachmentsAllOfFromJSON(json: any): SupplementalFormInstanceWithAttachmentsAllOf {
    return SupplementalFormInstanceWithAttachmentsAllOfFromJSONTyped(json, false);
}

export function SupplementalFormInstanceWithAttachmentsAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalFormInstanceWithAttachmentsAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attachments': !exists(json, 'attachments') ? undefined : ((json['attachments'] as Array<any>).map(SupplementalAttachmentFromJSON)),
    };
}

export function SupplementalFormInstanceWithAttachmentsAllOfToJSON(value?: SupplementalFormInstanceWithAttachmentsAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attachments': value.attachments === undefined ? undefined : ((value.attachments as Array<any>).map(SupplementalAttachmentToJSON)),
    };
}

